import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

export default function OrderError() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderId = searchParams.get("orderId");

  return (
    <div className="min-h-screen bg-[#FAF7F2] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl border border-amber-200 shadow-sm p-10 text-center">
        <div className="text-4xl mb-4">✗</div>
        <h1 className="text-2xl font-serif text-stone-900 mb-3">Greiðsla mistókst</h1>
        <p className="text-stone-500 font-serif text-sm mb-6">
          Greiðslan tókst ekki eða var aflýst. Engin upphæð hefur verið skuldfærð.
        </p>

        {orderId && (
          <p className="text-xs text-stone-400 font-serif mb-6">
            Pöntunarnúmer: <span className="font-mono">{orderId}</span>
          </p>
        )}

        <button
          onClick={() => navigate("/pontun")}
          className="w-full h-12 rounded-xl bg-[#C29979] text-white font-serif uppercase text-sm hover:bg-[#b08060] transition-colors"
        >
          Reyna aftur
        </button>
        <a
          href="/"
          className="block mt-3 text-stone-400 hover:text-[#C29979] font-serif text-sm transition-colors"
        >
          Til baka á forsíðu
        </a>
      </div>
    </div>
  );
}
